import CountAmenityList
    from "@CheckOrder/features/amenities/features/countAmenity/features/list/components/CountAmenityList";
import React from "react";
import AddSelectedAmenities from "@CheckOrder/features/amenities/components/AddSelectedAmenities";
import useCreateTotalPriceOfCurrentlySelectedAmenities
    from "@CheckOrder/features/amenities/features/countAmenity/features/modal/hooks/useCreateTotalPriceOfCurrentlySelectedAmenities";
import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";
import getGroupTranslationAndIcon
    from "@CheckOrder/features/amenities/features/countAmenity/functions/getGroupTranslationAndIcon";
import useGetAmenitiesCurrency from "@CheckOrder/features/amenities/hooks/useGetAmenitiesCurrency";

import useSingleAndReturnAmenitiesSelectTabs
    from "@CheckOrder/features/amenities/hooks/useSingleAndReturnAmenitiesSelectTabs";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import Pills from "@Generic/buttons/Pills";
import {
    CountAmenitySelectedType
} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenitySelected.type";
import {SetStateType} from "@/types/generic/SetState.type";
import MobileOverlayActionSheetHeader from "@MobileOverlays/components/MobileOverlayActionSheetHeader";
import MobileOverlayActionSheetAction from "@MobileOverlays/components/MobileOverlayActionSheetAction";

interface MobileAmenityOverlayCountAmenitiesProps {
    pairedAmenityGroups: PairedSingleAndReturnAmenitiesType
    closeAndUpdate: () => void,
    closeWithoutUpdating: () => void,
    singleSelectedAmenities: Record<string, CountAmenitySelectedType>
    setSingleSelectedAmenities: SetStateType<Record<string, CountAmenitySelectedType>>
    returnSelectedAmenities: Record<string, CountAmenitySelectedType>
    setReturnSelectedAmenities: SetStateType<Record<string, CountAmenitySelectedType>>
}

function MobileAmenityOverlayCountAmenities(props: MobileAmenityOverlayCountAmenitiesProps) {
    const {
        pairedAmenityGroups,
        closeAndUpdate,
        closeWithoutUpdating,
        singleSelectedAmenities,
        setSingleSelectedAmenities,
        returnSelectedAmenities,
        setReturnSelectedAmenities,
    } = props

    const {
        translations: {
            ctaDescription: ctaDescriptionLabel,
            modal: {
                title,
                cta,
            },
        },
    } = getGroupTranslationAndIcon(pairedAmenityGroups)

    const {
        totalPrice,
    } = useCreateTotalPriceOfCurrentlySelectedAmenities(
        pairedAmenityGroups,
        singleSelectedAmenities,
        returnSelectedAmenities
    )

    const {sign} = useGetAmenitiesCurrency()

    const {isReturn} = useAppSelector((state) => (state.checkOrder.ticket))
    const {selectedTab, tabs} = useSingleAndReturnAmenitiesSelectTabs()

    return (
        <>
            <MobileOverlayActionSheetHeader
                closeSheet={closeWithoutUpdating}
                className="amenities-overlay__header"
            >
                {isReturn && (
                    <Pills
                        pills={tabs}
                        wrapperClassName="gb--pill-container ticket-amenities__direction-pills"
                        tabClassName="gb--pill amenities-direction-pill"
                    />
                )}
            </MobileOverlayActionSheetHeader>
            <div className="amenities-overlay__content">
                <h2>{title}</h2>
                <p>{ctaDescriptionLabel}</p>
                <CountAmenityList
                    pairedAmenityGroups={pairedAmenityGroups}
                    selectedTab={selectedTab}
                    singleSelectedAmenities={singleSelectedAmenities}
                    returnSelectedAmenities={returnSelectedAmenities}
                    setSingleSelectedAmenities={setSingleSelectedAmenities}
                    setReturnSelectedAmenities={setReturnSelectedAmenities}
                />
            </div>
            <MobileOverlayActionSheetAction
                className="amenities-overlay__action"
            >
                <AddSelectedAmenities
                    closeAndUpdate={closeAndUpdate}
                    cta={cta}
                    total={totalPrice !== 0 ? `${totalPrice} ${sign}` : "-"}
                />
            </MobileOverlayActionSheetAction>
        </>
    )
}

export default MobileAmenityOverlayCountAmenities